import { Users, Laptop, Briefcase, Building, Wrench, Package } from 'lucide-react';
import type { ExpenseCategory } from '@/hooks/useCompanyExpenses';

export interface ExpenseGroup {
  key: string;
  label: string;
  icon: React.ReactNode;
  categories: ExpenseCategory[];
  addLabel: string;
}

export const EXPENSE_GROUPS: ExpenseGroup[] = [
  {
    key: 'staff',
    label: 'Staff & Operations',
    icon: <Users className="h-5 w-5" />,
    categories: ['office_staff'],
    addLabel: 'Add Staff Member',
  },
  {
    key: 'technology',
    label: 'Technology & Systems',
    icon: <Laptop className="h-5 w-5" />,
    categories: ['crm', 'telephone_systems', 'software'],
    addLabel: 'Add Tech Expense',
  },
  {
    key: 'professional',
    label: 'Professional Services',
    icon: <Briefcase className="h-5 w-5" />,
    categories: ['accounting', 'legal', 'insurance'],
    addLabel: 'Add Service',
  },
  {
    key: 'field_techs',
    label: 'Field Technicians',
    icon: <Wrench className="h-5 w-5" />,
    categories: ['field_techs'],
    addLabel: 'Add Field Tech',
  },
  {
    key: 'facilities',
    label: 'Facilities & Overhead',
    icon: <Building className="h-5 w-5" />,
    categories: ['rent', 'utilities', 'marketing'],
    addLabel: 'Add Facility Cost',
  },
  {
    key: 'general',
    label: 'General Expenses',
    icon: <Package className="h-5 w-5" />,
    categories: ['general', 'other'],
    addLabel: 'Add Expense',
  },
];
